export const INTEGRATE_SUITE_CRM =
  'APP/STORES/PLATFORM_COMPONENT/CRM/SUITE_CRM/INTEGRATE'
export const INTEGRATE_SUITE_CRM_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/CRM/SUITE_CRM/INTEGRATE_SUCCESS'
export const INTEGRATE_SUITE_CRM_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/CRM/SUITE_CRM/INTEGRATE_ERROR'
